import React, { useState } from "react";
import useStyles from "./style";
import { FaChevronDown } from "react-icons/fa6";
import { Select, Text } from "@mantine/core";
import { MdGridView } from "react-icons/md";
import { HiMenu } from "react-icons/hi";

function StaffRowGridRadio({ onChange }) {
  const [selected, setSelected] = useState("grid");
  const { classes } = useStyles();

  const change = (val) => {
    onChange?.(val);
    setSelected(val);
  };
  return (
    <div className={classes.row}>
      <div className={classes.innerRow}>
      <div
        className={
          selected === "list" ? classes.radioItemSelected : classes.radioItem
        }
        // style={{borderTopRightRadius: selected === "list" ? "4px" : 0 }}
        onClick={() => change("list")}
      >
        {/* <img
          src={"/assets/images/row.png"}
          className={classes.radioImage}
          alt="list"
        /> */}
        <HiMenu />
        <Text>List</Text>
      </div>
      <div
        onClick={() => change("grid")}
        className={
          selected === "grid" ? classes.radioItemSelected : classes.radioItem
        }
      >
        {/* <img
          src={"/assets/images/grid.png"}
          className={classes.radioImage}
          alt="grid"
        /> */}
        <MdGridView />
        <Text>Grid</Text>
      </div>
      </div>
    </div>
  );
}

function StaffFileFolderRadio({ onChange }) {
  const [selected, setSelected] = useState("folder");
  const { classes } = useStyles();

  const change = (val) => {
    onChange?.(val);
    setSelected(val);
  };
  return (
    <Select
      aria-label="Select File or Folder"
      value={selected}
      variant="unstyled"
      onChange={(val) => change(val)}
      className={classes.select}
      data={[
        { value: "file", label: "Files" },
        { value: "folder", label: "Folders" },
      ]}
      rightSection={<FaChevronDown />}
    />
  );
}

export { StaffRowGridRadio, StaffFileFolderRadio };
